import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2021-07-01T12:00",
		title: `
<h4>燕・弥彦医療介護センターより</h4>
<p class="paragraph-indent">
●スキルアップセミナー開催のご案内<br>
参加対象：燕弥彦地域の看護職・介護職・介護支援専門員等<br>
・<a href="${topicsDir}/2021/07-skill-up-seminar.pdf">スキルアップセミナー開催のご案内</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	},
	{
		date: "2021-07-16T12:00",
		title: `
<h4>三条市地域包括ケア総合推進センターより</h4>
<p class="paragraph-indent">
●令和3年度　講演会「食支援を共に考える」<br>
参加対象：三条市内の医療・介護・福祉等の専門職<br>
・<a href="${topicsDir}/2021/07-program.pdf">プログラム、申込方法</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
